import {useActions, useGetters, useMutators, useState, update, remove, removeLayerGroup, addLayerGroup} from './_map';
import {MAP_OBJECT_TYPE_OBJECT} from "@/js/constants";
import axios from "axios";
import ObjectPopup from "@/js/Components/MapPopup/ObjectPopup.vue";
import useOptimizedList from "@/js/Store/_optimizedList.js";
import {getFormLocalStorage, storeToLocalStorage} from "@/js/helpers.js";

export default {
    namespaced: true,
    state: {
        ...useState(),
        popupComponent: ObjectPopup,
        layers: null,

        listMap: {},

        latestSelected: null,

        update: true,
        updateInterval: 5000,
        updateTimestamp: null,
        updateTimer: null,

        fallow: true,
        fallowLoaded: false,
        fallowTimestamp: null,
        fallowTimer: null,
        fallowIds: [],

        updateFull: null,
        updateFullTimer: null,

        params: { grouped: 1 },
        animate: null,
        showTotalDistance: false,
        showFullAddress: false,
        hash: null,

        updates: true,

        customDeviceAdd: false,
        listView: false,
    },
    getters: {
        ...useGetters(),
        hash: state => state.hash,
        updateInterval: state => state.updateInterval,
        animate: state => state.animate,
        customDeviceAdd: state => state.customDeviceAdd,
        updateTimestamp: state => state.updateTimestamp,
        showTotalDistance: state => state.showTotalDistance,
        showFullAddress: state => state.showFullAddress,
        listView: state => state.listView,
        fallowLoaded:  state => state.fallowLoaded,
        loadFallow:  state => {
            state.fallowLoaded = true;
            return state.fallowIds;
        },
    },
    mutations: {
        ...useMutators(),

        ...useOptimizedList(update, remove),

        listView(state, status) {
            state.listView = status;
        },

        sharingHash(state, hash) {
            state.hash = hash;
        },

        animate(state, animate) {
            state.animate = parseInt(animate);
        },

        showTotalDistance(state, status) {
            state.showTotalDistance = !!status;
        },

        showFullAddress(state, status) {
            state.showFullAddress = !!status;
        },

        updateTimestamp(state, time) {
            state.updateTimestamp = time;
        },

        fallow(state, id) {
            if (!id) return;
            const index = state.fallowIds.findIndex(v => v.toString() === id.toString());
            if (index !== -1) return;
            state.fallowIds.push(id);
            // storeToLocalStorage('fallow', JSON.stringify(state.fallowIds))
        },

        unFallow(state, id) {
            if (!id) return;
            const index = state.fallowIds.findIndex(v => v.toString() === id.toString());
            if (index === -1) return;
            state.fallowIds.splice(index, 1);
            // storeToLocalStorage('fallow', JSON.stringify(state.fallowIds))
        },

        customDeviceAdd(state, status) {
            state.customDeviceAdd = status;
        },

        removeLayerGroup(state) {
            state.layerGroup.clearLayers();
            removeLayerGroup(state.layerGroup);
        },

        addLayerGroup(state) {
            addLayerGroup(state.layerGroup);
            state.layerGroup.add(state.list, state.layer);
        },

        select(state, id) {
            state.selected = id;
            if (!id) return;
            state.latestSelected = id;
        },

        selectLatestSelected(state) {
            state.selected = state.latestSelected;
        }
    },
    actions: {
        ...useActions(),
        changeActive({ state}, data) {
            return new Promise((resolve, reject) => {
                return axios.put('/devices/change-active', data).then((response) => {
                    resolve(response?.data);
                }).catch((error) => {
                    reject(error);
                })
            });
        },
        uploadImage({ state }, { id, data }) {
            return new Promise((resolve, reject) => {
                axios.post(`/object/image/${id}`, data).then((response) => {
                    resolve();
                });
            });
        },
        deleteImage({ state }, id) {
            return new Promise((resolve, reject) => {
                axios.delete(`/object/image/${id}`).then((response) => {
                    resolve();
                });
            });
        },

        load({state, dispatch}, id) {
            return dispatch('loadMapObjects', {
                name: MAP_OBJECT_TYPE_OBJECT,
                params: { id, full: true },
                add: false
            })
        },

        stopUpdate({ state }) {
            clearTimeout(state.updateTimer);
            state.update = false;
        },

        startUpdate({ state, dispatch }) {
            if (!state.updates) return;
            state.update = true;
            dispatch('update');
        },

        updateFullObject({ state, dispatch }, id) {
            if (!state.updates) return;
            if (state.updateFull === id) return;
            state.updateFull = id;
            if (!state.updateFull) return;
            dispatch('updateFull');
        },

        stopAllUpdates({ state }) {
            state.updates = false;
        },

        resetAllUpdates({ state, commit }) {
            state.updates = true;
        },

        updateFull({ state, dispatch }) {
            clearTimeout(state.updateFullTimer);
            if (!state.updateFull || !state.updates) return;

            const object = state.list.find(o => o.id.toString() === state.updateFull.toString());
            if (!object) {
                state.updateFull = null;
                return;
            }
            object.loading = true;
            let params = Object.assign({ id: [state.updateFull], full: true }, state.mapFilter);
            dispatch('loadMapObjects', {
                name: MAP_OBJECT_TYPE_OBJECT,
                params,
            }).then((response) => {
                object.loading = false;
                state.updateFullTimer = setTimeout(() => {
                    dispatch('updateFull');
                }, state.updateInterval);
            });
        },

        update({ state, dispatch, rootState }) {
            clearTimeout(state.updateTimer);
            if (!state.update || !state.updates) return;

            let params = { time: state.updateTimestamp };
            if (!state.hash) {
                Object.assign(params, state.mapFilter);
            }

            dispatch('loadMapObjectsRecursively', {
                name: MAP_OBJECT_TYPE_OBJECT,
                params,
            }).then((response) => {
                state.updateTimestamp = response?.headers?.time;
                state.mapFilter.time = state.updateTimestamp;
                state.updateTimer = setTimeout(() => {
                    dispatch('update');
                }, state.updateInterval);
            }).catch((error) => {
                if (error.response?.status == 410 && state.hash) {
                    rootState.router.push(`${__PREFIX__}/410`);
                }
            });
        },

        startFallow({ state, dispatch}) {
            state.fallow = true;
            dispatch('fallow');
        },

        stopFallow({ state, dispatch }) {
            clearTimeout(state.fallowTimer);
            state.fallow = false;
        },

        fallow({ state, dispatch }) {
            clearTimeout(state.fallowTimer);
            if (!state.fallow || !state.fallowIds.length) {
                state.fallowTimer = setTimeout(() => {
                    dispatch('fallow');
                }, state.updateInterval);
                return;
            }

            const params = {
                fallow: state.fallowIds,
                time: state.fallowTimestamp
            };
            dispatch('loadMapObjects', {
                name: MAP_OBJECT_TYPE_OBJECT,
                params,
                add: false
            }).then((response) => {
                state.fallowTimestamp = response.headers.time;
                state.fallowTimer = setTimeout(() => {
                    dispatch('fallow');
                }, state.updateInterval);
            });
        },

        sendGprsCommand({ state }, data) {
            return new Promise((resolve, reject) => {
                const url = data.url || '/command/send/gprs';
                delete data.url;
                axios.post(url, data).then((response) => {
                    const result = parseSendCommandResponse(response.data);
                    result?.type === 'error' || result?.type === 'warning' ? reject(result) : resolve(result);
                }).catch((error) => {
                    reject(parseSendCommandError(error));
                });
            });
        },
    },
}

export function parseSendCommandResponse(response) {
    if (response.error) {
        return {
            message: response.error,
            type: 'error'
        };
    } else if (response.warnings) {
        return {
            message: response.warnings[0],
            type: 'warning'
        }
    } else {
        return response.message;
    }
}

export function parseSendCommandError(error) {
    return {
        message: error?.response?.message,
        type: 'error'
    };
}